import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "./Onboard.css";
import user from "../../assets/img/person.svg";
import { useState, useEffect } from "react";
import { Accordion, Placeholder } from "react-bootstrap";

import { Button, Modal, ListGroup } from "react-bootstrap";

import X from "../../assets/img/x.png";

import { useRef } from "react";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateAadhaarImageBack } from "../../store/actions/HrmsOnboard";
import Constant from "../../utils/constant";
import { useLocation } from "react-router-dom";

import ImagePlaceholder from "../../assets/img/img_placeholder.png";
import logo from "../../assets/img/logo.png";
export default function ViewDetails() {
  const location = useLocation();
  const [errors, setErrors] = useState({});

  const [photoLoad, setPhotoLoad] = useState(false);
  const { employee, workingCompany, familyDetail } = location.state || {};

  const employeeId = employee?.employee_id;

  const [employeeData, setEmployeeData] = useState(employee || null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editableSection, setEditableSection] = useState(null);
  const [isResignationChecked, setIsResignationChecked] = useState(false);

  const [isDisabled, setIsDisabled] = useState(false);
  // const [selectedStatus, setSelectedStatus] = useState("Active User");
  const [selectedStatus, setSelectedStatus] = useState("");
  useEffect(() => {
    if (employeeData?.status) {
      setSelectedStatus(employeeData.status);
    }
  }, [employeeData]);
  const fileInputRef = useRef(null);
  const toggleEditMode = (section) => {
    if (editableSection === section) {
      setEditableSection(null); // collapse if same section clicked again
    } else {
      setEditableSection(section);
    }
  };
  const deleteFile = (fieldName) => {
    setEmployeeData((prev) => ({
      ...prev,
      [fieldName]: "",
    }));
  };
  const handleFileChange = async (fieldName, event) => {
    const file = event.target.files[0];
    if (!file) return;

    const uploaded = await uploadDocument(file);

    if (uploaded?.photoURL) {
      setEmployeeData((prev) => ({
        ...prev,
        [fieldName]: uploaded.photoURL,
      }));
    } else {
      alert("File upload failed");
    }
  };
  const uploadDocument = async (file) => {
    try {
      const formData = new FormData();
      formData.append("documentData", file);

      const response = await fetch(Constant.BASE_URL + "hrms/addDocuments", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.status === 1) {
        return {
          photoURL: result.photoURL,
          key: result.key,
        };
      } else {
        console.error("Upload failed:", result.message);
        return null;
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      return null;
    }
  };

  const [checkedItems, setCheckedItems] = useState([]);
  const [checklistData, setChecklistData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [documents, setDocuments] = useState([]);
  const employeeIdd = "859633";
  const fetchChecklist = async () => {
    if (!employeeId) {
      alert("Employee ID is not available.");
      return;
    }
    try {
      const response = await fetch(
        // `http://localhost:1051/hrms/getEmployeeChecklist`,
        Constant.BASE_URL + `hrms/getEmployeeChecklist`,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ employee_id: employeeId }),
        }
      );
      const result = await response.json();

      if (result.status === 1) {
        setChecklistData(result.checklistData);
      } else {
        console.error("Failed to fetch checklist:", result.message);
      }
    } catch (error) {
      console.error("Error fetching checklist:", error);
    }
  };

  const handleOpenModal = () => {
    fetchChecklist();
    setShowModal(true);
  };

  const checklistMap = [
    { key: "resume", name: "Resume" },
    { key: "profile_pic", name: "Profile Picture" },
    { key: "degree_upload", name: "Degree Upload" },
    { key: "class_10_marksheet", name: "Class 10 Marksheet" },
    { key: "class_12_marksheet", name: "Class 12 Marksheet" },
    {
      key: "highest_qualification_marksheet",
      name: "Highest Qualification Marksheet",
    },
    {
      key: "certification_additional_courses",
      name: "Certification for Additional Courses",
    },
    {
      key: "certification_skill_acquired",
      name: "Certification for Skill Acquired",
    },
    { key: "pan", name: "PAN Card" },
    { key: "adhar", name: "Aadhaar Card" },
    { key: "bank_document_upload", name: "Bank Document Upload" },
    { key: "passport", name: "Passport" },
    { key: "policicue_offer_letter", name: "Policicue Offer Letter" },
    { key: "relieving_letter", name: "Relieving Letter" },
  ];
  const [woorkingCompany, setWorkingCompany] = useState(
    workingCompany || [
      {
        company_name: "",
        job_title: "",
        start_date: "",
        end_date: "",
        pay_slip: "",
        relieving_letter: "",
        signed_resignation_letter: "",
        offer_letter: "",
      },
    ]
  );

  const [familyData, setfamilyData] = useState(
    familyDetail || [
      {
        member_name: "",
        relation: "",
        member_dob: "",
        occupation: "",
        member_contact_number: "",
      },
    ]
  );
  const handleCheckboxChangee = (index) => {
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index] = !updatedCheckedItems[index];
    setCheckedItems(updatedCheckedItems);
  };
  const addJobSection = () => {
    setWorkingCompany((prevCompanies) => [
      ...prevCompanies,
      {
        company_name: "",
        job_title: "",
        start_date: "",
        end_date: "",
        pay_slip: "",
        relieving_letter: "",
        signed_resignation_letter: "",
        offer_letter: "",
      },
    ]);
  };
  const AddFamilyMember = () => {
    setfamilyData((prev) => [
      ...prev,
      {
        member_name: "",
        relation: "",
        member_dob: "",
        occupation: "",
        member_contact_number: "",
      },
    ]);
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const payload = {
        employeeData,
        workingCompany: woorkingCompany,
        familyDetail: familyData,
      };

      await axios.post(Constant.BASE_URL + `hrms/updateEmployee`, payload);

      alert("Employee details updated successfully!");

      await fetchEmployeeDetails(employeeData.id);
      setEditableSection(null);
    } catch (err) {
      console.error("Error updating employee data:", err);
      alert("Failed to update employee details.");
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
    if (!e.target) return; // Guard clause for safety
    const { name, value } = e.target;
    setEmployeeData((prev) => ({ ...prev, [name]: value }));
  };
  const handleFamilyInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFamily = [...familyData];
    updatedFamily[index] = {
      ...updatedFamily[index],
      [name]: value,
    };
    setfamilyData(updatedFamily);
  };

  const handleWorkingCompanyInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedCompany = [...woorkingCompany];
    updatedCompany[index] = {
      ...updatedCompany[index],
      [name]: value,
    };
    setWorkingCompany(updatedCompany);
  };

  // const removeJobSection = (index) => {
  //   if (woorkingCompany.length > 1) {
  //     setWorkingCompany((prevCompanies) =>
  //       prevCompanies.filter((_, i) => i !== index)
  //     );
  //   }
  // };
  const removeJobSection = async (index) => {
    const companyToDelete = woorkingCompany[index];

    // If the company has an ID, it exists in DB
    if (companyToDelete.id) {
      const confirmed = window.confirm(
        "Are you sure you want to delete this record?"
      );
      if (!confirmed) return;

      const success = await deleteWorkingCompanyFromAPI(companyToDelete.id);
      if (!success) {
        alert("Failed to delete company record from server.");
        return;
      }
    }

    // Remove from state (UI)
    if (woorkingCompany.length > 1) {
      setWorkingCompany((prevCompanies) =>
        prevCompanies.filter((_, i) => i !== index)
      );
    }
  };

  const deleteWorkingCompanyFromAPI = async (companyId) => {
    try {
      const response = await axios.post(
        Constant.BASE_URL + `hrms/deleteEmployeeWorkCompany`,
        { id: companyId }
      );
      await fetchEmployeeDetails(employeeData.id);
      if (response.data.status === 1) {
        return true;
      } else {
        console.error("Failed to delete:", response.data.message);
        return false;
      }
    } catch (error) {
      console.error("Error deleting company:", error);
      return false;
    }
  };

  useEffect(() => {
    if (employeeId && !employee) {
      fetchEmployeeDetails(employeeId);
    }
  }, [employeeId, employee]);

  // const fetchEmployeeDetails = async (id) => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       Constant.BASE_URL + `hrms/getEmployeeList?page=3&limit=1`,
  //       { id }
  //     );

  //     if (response.data && response.data.data && response.data.data[0]) {
  //       const emp = response.data.data[0];
  //       setEmployeeData(emp.employeeData || {});
  //       setWorkingCompany(emp.workingCompany || []);
  //       setfamilyData(emp.familyDetail || []);
  //     } else {
  //       setError("Employee not found.");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching employee data:", err);
  //     setError("Failed to fetch employee data.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchEmployeeDetails = async (id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        Constant.BASE_URL + `hrms/viewEmployee`,
        { id }
      );

      if (response.data && response.data.data) {
        const emp = response.data.data;
        setEmployeeData(emp.employeeData || {});
        setWorkingCompany(emp.workingCompany || []);
        setfamilyData(emp.familyDetail || []);
      } else {
        setError("Employee not found.");
      }
    } catch (err) {
      console.error("Error fetching employee data:", err);
      setError("Failed to fetch employee data.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    alert("Employee details submitted successfully!");
  };

  if (loading) {
    return <p>Loading employee details...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!employeeData) {
    return <p>No employee selected.</p>;
  }

  return (
    <div className="AgentCustomer">
      {/*<!-- Main Body --> */}

      <div className="container-fluid my-2">
        <div className="row">
          <main className="mainBodyContainer">
            <div className="row my-2">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                <div
                  className="py-3  d-flex "
                  style={{
                    justifyContent: "space-between",
                    paddingRight: "30px",
                  }}
                >
                  <h4
                    className="text-uppercase "
                    style={{
                      fontFamily: "ErasDemiITC",
                      fontWeight: "normal",
                    }}
                  >
                    Employee Details{" "}
                  </h4>

                  <button className="btn btn-primary">
                    {employeeData.status}
                  </button>
                </div>
              </div>
            </div>
            <div className="row py-0">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-0 px-3">
                <div className="px-2 rounded-3">
                  <hr className="my-0" />
                </div>
              </div>
            </div>
            <div className="row py-0">
              <div className="multisteps-form">
                <div className="row"></div>

                <div className="row">
                  <div className="col-12 col-lg-12 m-auto">
                    <form className="multisteps-form__form">
                      <div
                        className="multisteps-form__panel rounded js-active"
                        data-animation="scaleIn"
                      >
                        {/* Personal info section */}
                        <div
                          className="bg-white p-4 shadow  pb-5 rounded-3"
                          style={{
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between border-bottom pb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Personal information
                              </h4>
                            </div>
                            <div className="bg-white">
                              <button
                                type="button"
                                className="btn btn-transparent"
                                onClick={() => toggleEditMode("personal")}
                                id="icueEditGenInfoDetails"
                              >
                                {editableSection === "personal" ? (
                                  <>
                                    <i className="bi bi-x-circle" />
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-pencil" /> Edit
                                  </>
                                )}
                              </button>
                              {editableSection === "personal" && (
                                <button
                                  type="button"
                                  className="btn btn-primary ms-2"
                                  onClick={handleUpdate}
                                  id="icueSaveGenInfoDetails"
                                >
                                  <i className="bi bi-save" /> Update
                                </button>
                              )}
                            </div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row pt-4">
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemTitle"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Title
                                </label>
                                <select
                                  //   value={employeeData.title}
                                  onChange={handleInputChange}
                                  value={employeeData.title || ""}
                                  readOnly={editableSection !== "personal"}
                                  id="icuePersonalFormCueMemTitle"
                                  name="title"
                                  className={`form-select text-uppercase${
                                    isEditMode ? "" : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="mr.">mr.</option>
                                  <option value="ms.">ms.</option>
                                  <option value="mrs.">mrs.</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemFname"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  First Name
                                </label>
                                <input
                                  value={employeeData.first_name || ""}
                                  onChange={handleInputChange}
                                  readOnly={editableSection !== "personal"}
                                  type="text"
                                  id="icuePersonalFormCueMemFname"
                                  name="first_name"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                />
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemLName"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Last name
                                </label>
                                <input
                                  type="text"
                                  id="icuePersonalFormCueMemLName"
                                  name="last_name"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="abc"
                                  value={employeeData.last_name || ""}
                                  onChange={handleInputChange}
                                  readOnly={editableSection !== "personal"}
                                />
                              </div>
                              <div>
                                <hr />
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemEmail"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  E-mail
                                </label>
                                <input
                                  type="email"
                                  value={employeeData.email || ""}
                                  readOnly={editableSection !== "personal"}
                                  id=""
                                  name="email"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="xyz@gmail.com"
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemPhoneNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Contact Number
                                </label>
                                <input
                                  value={employeeData.contact_number || ""}
                                  readOnly={editableSection !== "personal"}
                                  type="text"
                                  id="icuePersonalFormCueMemPhoneNo"
                                  name="contact_number"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="xxxxxxxxxx"
                                  onChange={handleInputChange}
                                />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemMobNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Emergency Contact Number
                                </label>
                                <input
                                  value={
                                    employeeData.emergency_contact_number || ""
                                  }
                                  readOnly={editableSection !== "personal"}
                                  type="text"
                                  id="icuePersonalFormCueMemMobNo"
                                  name="emergency_contact_number"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="xxxxxxxxxx"
                                  onChange={handleInputChange}
                                />
                              </div>

                              <div>
                                <hr />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemPanNo"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Date Of Birth
                                </label>
                                <input
                                  value={
                                    employeeData.dob
                                      ? new Date(employeeData.dob)
                                          .toISOString()
                                          .split("T")[0]
                                      : ""
                                  }
                                  readOnly={editableSection !== "personal"}
                                  type="date"
                                  onChange={handleInputChange}
                                  id="icuePersonalFormCueMemPanNo"
                                  name="dob"
                                  className={`form-control my-text my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="alwpg5809l"
                                />
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor=""
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Gender
                                </label>
                                <select
                                  value={employeeData.gender || ""}
                                  readOnly={editableSection !== "personal"}
                                  id=""
                                  onChange={handleInputChange}
                                  name="gender"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="selft employed">Male</option>
                                  <option value="self">Female</option>
                                  <option value="employed">Other</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                <label
                                  htmlFor="icuePersonalFormCueMemProfession"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Marital Status
                                </label>
                                <select
                                  onChange={handleInputChange}
                                  id="icuePersonalFormCueMemProfession"
                                  name="marital_status"
                                  value={employeeData.marital_status || ""}
                                  readOnly={editableSection !== "personal"}
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="selft employed">Yes</option>
                                  <option value="self">No</option>
                                </select>
                              </div>
                              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-3">
                                <label
                                  htmlFor="icuePersonalFormCueMemLName"
                                  className="form-label icueTextPrimary icuePersonalInfoLabel"
                                >
                                  Blood Group
                                </label>
                                <input
                                  type="text"
                                  id="icuePersonalFormCueMemLName"
                                  name="blood_group"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "personal"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=""
                                  value={employeeData.blood_group || ""}
                                  onChange={handleInputChange}
                                  readOnly={editableSection !== "personal"}
                                />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.resume &&
                                editableSection === "personal" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Upload Resume
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="resume"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("resume", e)
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.resume && (
                                      <p className="p-error">{errors.resume}</p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Resume
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "personal"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "personal")
                                          document
                                            .getElementById("resume")
                                            .click();
                                      }}
                                    >
                                      {employeeData.resume?.endsWith(".pdf") ? (
                                        <iframe
                                          src={employeeData.resume}
                                          width="100%"
                                          height="190px"
                                          title="Resume Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.resume ||
                                            ImagePlaceholder
                                          }
                                          alt="resume"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "personal" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("resume");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="resume"
                                            className="d-none"
                                            name="resume"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("resume", e)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.profile_pic &&
                                editableSection === "personal" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Upload Photo
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="profile_pic"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("profile_pic", e)
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.profile_pic && (
                                      <p className="p-error">
                                        {errors.profile_pic}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Photo
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "personal"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "personal")
                                          document
                                            .getElementById("profile_pic")
                                            .click();
                                      }}
                                    >
                                      {employeeData.profile_pic?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={employeeData.profile_pic}
                                          width="100%"
                                          height="190px"
                                          title="profile_pic Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.profile_pic ||
                                            ImagePlaceholder
                                          }
                                          alt="profile_pic"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "personal" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("profile_pic");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="profile_pic"
                                            className="d-none"
                                            name="profile_pic"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("profile_pic", e)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <Accordion
                                defaultActiveKey="0"
                                flush
                                className="pt-5"
                              >
                                <Accordion.Item eventKey="0">
                                  <Accordion.Header className="icueTextPrimary ">
                                    Contact Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {" "}
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                      <label
                                        htmlFor="icuePersonalFormCueMemPin"
                                        className="form-label icueTextPrimary icuePersonalInfoLabel"
                                      >
                                        Residential Address
                                      </label>
                                      <input
                                        value={
                                          employeeData.residential_address || ""
                                        }
                                        readOnly={
                                          editableSection !== "personal"
                                        }
                                        type="text"
                                        id="icuePersonalFormCueMemPin"
                                        name="residential_address"
                                        className={`form-control my-text my-text my-text ${
                                          editableSection === "personal"
                                            ? ""
                                            : "bg-white text-muted"
                                        }`}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          landmark
                                        </label>
                                        <input
                                          value={employeeData.landmark || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="landmark"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          city
                                        </label>
                                        <input
                                          value={employeeData.city || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="city"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>

                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          State
                                        </label>
                                        <input
                                          value={employeeData.state || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="state"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <input
                                          value={employeeData.pincode || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pincode"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          defaultValue={12211}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Country
                                        </label>
                                        <input
                                          value={employeeData.country || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="country"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          defaultValue={12211}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                      <label
                                        htmlFor="icuePersonalFormCueMemPin"
                                        className="form-label icueTextPrimary icuePersonalInfoLabel"
                                      >
                                        Permanent Address
                                      </label>
                                      <input
                                        value={
                                          employeeData.permanent_address || ""
                                        }
                                        readOnly={
                                          editableSection !== "personal"
                                        }
                                        type="text"
                                        id="icuePersonalFormCueMemPin"
                                        name="permanent_address"
                                        className={`form-control my-text my-text my-text ${
                                          editableSection === "personal"
                                            ? ""
                                            : "bg-white text-muted"
                                        }`}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          landmark
                                        </label>
                                        <input
                                          value={employeeData.pa_landmark || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pa_landmark"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          city
                                        </label>
                                        <input
                                          value={employeeData.pa_city || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pa_city"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>

                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          State
                                        </label>
                                        <input
                                          value={employeeData.pa_state || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pa_state"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                    <div className="row pt-2">
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <input
                                          value={employeeData.pa_pincode || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pa_pincode"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          defaultValue={12211}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Country
                                        </label>
                                        <input
                                          value={employeeData.pa_country || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pa_country"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          defaultValue={12211}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                  <Accordion.Header className="icueTextPrimary">
                                    Bank Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div className="row pt-2">
                                      {/* Bank Name */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Bank Name
                                        </label>
                                        <input
                                          value={employeeData.bank_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="bank_name"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      {/* Account Holder Name */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Account Holder Name
                                        </label>
                                        <input
                                          value={
                                            employeeData.account_holder_name ||
                                            ""
                                          }
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="account_holder_name"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      {/* Account Number */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Account Number
                                        </label>
                                        <input
                                          value={
                                            employeeData.bank_account_number ||
                                            ""
                                          }
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="bank_account_number"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      {/* IFSC Code */}
                                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          IFSC Code
                                        </label>
                                        <input
                                          value={employeeData.ifsc_code || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="ifsc_code"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                      {/* Radio Buttons for Cheque Statement */}
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                        <label
                                          htmlFor=" "
                                          className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        >
                                          Cancelled cheque Photo
                                        </label>

                                        <div className="pt-2">
                                          {employeeData.bank_document_upload ? (
                                            <div className="img-preview">
                                              {/* Preview Image or PDF */}
                                              {employeeData.bank_document_upload.endsWith(
                                                ".pdf"
                                              ) ? (
                                                <iframe
                                                  // src={employeeData.bank_document_upload}
                                                  title="bank_document_upload Preview"
                                                  width="100%"
                                                  height="190px"
                                                  style={{
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                  }}
                                                ></iframe>
                                              ) : (
                                                <img
                                                  src={
                                                    employeeData.bank_document_upload
                                                  }
                                                  alt="bank document Preview"
                                                  style={{
                                                    maxHeight: "190px",
                                                    borderRadius: "4px",
                                                  }}
                                                />
                                              )}

                                              {/* Delete icon (only if editable) */}
                                              {/* {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )} */}
                                            </div>
                                          ) : (
                                            <div className="img-preview">
                                              <img
                                                src={ImagePlaceholder}
                                                alt="placeholder"
                                                style={{ height: "190px" }}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                      {/* Upload Cheque Photo */}
                                      {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                                        <label
                                          htmlFor="icuePersonalFormCueMemPin"
                                          className="form-label icueTextPrimary icuePersonalInfoLabel"
                                        >
                                          Pincode
                                        </label>
                                        <input
                                          value={employeeData.pincode || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          id="icuePersonalFormCueMemPin"
                                          name="pincode"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                          defaultValue={12211}
                                          onChange={handleInputChange}
                                        />
                                      </div> */}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                  <Accordion.Header className="icueTextPrimary ">
                                    Family Details
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {" "}
                                    {familyData.map((family, index) => (
                                      <div className="row" key={index}>
                                        {/* <div className="bg-white">
                                          <FontAwesomeIcon
                                            icon={faTrash}
                                            type="button"
                                            className="btn btn-transparent icueTextInfoLight"
                                            id="icueEditGennInfoDetails"
                                            onClick={() =>
                                              removeJobSection(index)
                                            }
                                            style={{
                                              float: "right",
                                              color: "red",
                                              cursor: "pointer",
                                              fontSize: "20px",
                                            }}
                                          />
                                        </div> */}

                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor="icuePersonalFormCueMemPin"
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Name of the Family Member
                                          </label>
                                          <input
                                            value={family.member_name || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            type="text"
                                            onChange={(e) =>
                                              handleFamilyInputChange(index, e)
                                            }
                                            id="icuePersonalFormCueMemPin"
                                            name="member_name"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`relation`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Relation
                                          </label>
                                          <input
                                            value={family.relation || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            type="text"
                                            onChange={(e) =>
                                              handleFamilyInputChange(index, e)
                                            }
                                            id={`relation-`}
                                            name="relation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`occupation`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Occupation
                                          </label>
                                          <input
                                            value={family.occupation || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            type="text"
                                            onChange={(e) =>
                                              handleFamilyInputChange(index, e)
                                            }
                                            id={`occupation-`}
                                            name="occupation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`member_contact_number`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Contact Number
                                          </label>
                                          <input
                                            value={
                                              family.member_contact_number || ""
                                            }
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            type="text"
                                            onChange={(e) =>
                                              handleFamilyInputChange(index, e)
                                            }
                                            id={`member_contact_number-`}
                                            name="member_contact_number"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`member_dob`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Date of Birth
                                          </label>
                                          <input
                                            value={
                                              family.member_dob
                                                ? new Date(family.member_dob)
                                                    .toISOString()
                                                    .split("T")[0]
                                                : ""
                                            }
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            type="date"
                                            onChange={(e) =>
                                              handleFamilyInputChange(index, e)
                                            }
                                            id={`member_dob-`}
                                            name="member_dob"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`jobTitle-`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Relation
                                          </label>
                                          <input
                                            value={family.relation}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            onChange={handleInputChange}
                                            type="text"
                                            id={`relation-`}
                                            name="relation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`jobTitle-`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Date OF Birth
                                          </label>
                                          <input
                                            value={family.relation || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            onChange={handleInputChange}
                                            type="text"
                                            id={`relation-`}
                                            name="relation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`jobTitle-`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Occupation
                                          </label>
                                          <input
                                            value={family.relation || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            onChange={handleInputChange}
                                            type="text"
                                            id={`relation-`}
                                            name="relation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div>
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                          <label
                                            htmlFor={`jobTitle-`}
                                            className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                          >
                                            Contact Number
                                          </label>
                                          <input
                                            value={family.relation || ""}
                                            readOnly={
                                              editableSection !== "personal"
                                            }
                                            onChange={handleInputChange}
                                            type="text"
                                            id={`relation-`}
                                            name="relation"
                                            // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                            className={`form-control my-text my-text my-text ${
                                              editableSection === "personal"
                                                ? ""
                                                : "bg-white text-muted"
                                            }`}
                                          />
                                        </div> */}
                                      </div>
                                    ))}
                                    {/* <div className="row">
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                        <label
                                          htmlFor={`member_name`}
                                          className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                        >
                                          Name of the Family Member
                                        </label>
                                        <input
                                          // value={family.member_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          // onChange={handleInputChange}
                                          id={`member_name-`}
                                          name="member_name"
                                          // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                        />
                                      </div>
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                        <label
                                          htmlFor={`member_name`}
                                          className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                        >
                                          Occupation
                                        </label>
                                        <input
                                          // value={family.member_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          // onChange={handleInputChange}
                                          id={`member_name-`}
                                          name="member_name"
                                          // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                        />
                                      </div>
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                        <label
                                          htmlFor={`member_name`}
                                          className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                        >
                                          Relation
                                        </label>
                                        <input
                                          // value={family.member_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          // onChange={handleInputChange}
                                          id={`member_name-`}
                                          name="member_name"
                                          // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                        />
                                      </div>
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                        <label
                                          htmlFor={`member_name`}
                                          className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                        >
                                          Date of Birth
                                        </label>
                                        <input
                                          // value={family.member_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          // onChange={handleInputChange}
                                          id={`member_name-`}
                                          name="member_name"
                                          // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                        />
                                      </div>
                                      <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                        <label
                                          htmlFor={`member_name`}
                                          className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                        >
                                          Contact Number
                                        </label>
                                        <input
                                          // value={family.member_name || ""}
                                          readOnly={
                                            editableSection !== "personal"
                                          }
                                          type="text"
                                          // onChange={handleInputChange}
                                          id={`member_name-`}
                                          name="member_name"
                                          // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                          className={`form-control my-text my-text my-text ${
                                            editableSection === "personal"
                                              ? ""
                                              : "bg-white text-muted"
                                          }`}
                                        />
                                      </div>
                                    </div> */}
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>

                              <div>
                                <hr />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Educational Section */}
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Educational Information
                              </h4>
                            </div>
                            <div className="bg-white">
                              <button
                                type="button"
                                className="btn btn-transparent"
                                onClick={() => toggleEditMode("educational")}
                                id="icueEditGenInfoDetails"
                              >
                                {editableSection === "educational" ? (
                                  <>
                                    <i className="bi bi-x-circle" /> Cancel
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-pencil" /> Edit
                                  </>
                                )}
                              </button>
                              {editableSection === "educational" && (
                                <button
                                  type="button"
                                  className="btn btn-primary ms-2"
                                  onClick={handleUpdate}
                                  id="icueSaveGenInfoDetails"
                                >
                                  <i className="bi bi-save" /> Update
                                </button>
                              )}
                            </div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueGenFormCueMember"
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Highest Qualification
                                </label>
                                <select
                                  value={
                                    employeeData.highest_qualification || ""
                                  }
                                  onChange={handleInputChange}
                                  readOnly={editableSection !== "educational"}
                                  id="icueGenFormCueMember"
                                  name="highest_qualification"
                                  // className="form-select  text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                  // className={`form-control my-text my-text my-text text-uppercase${
                                  //   editableSection === "educational"
                                  //     ? ""
                                  //     : "bg-white text-muted"
                                  // }`}
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="HighSchool">
                                    High School
                                  </option>
                                  <option value="Bachelors">Bachelors</option>
                                  <option value="Masters">Masters</option>
                                  <option value="PhD">PhD</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Degree
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.dgree || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="dgree"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Institution/University Name
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={
                                    employeeData.institute_university_name || ""
                                  }
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="institute_university_name"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" "
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Year of Graduation
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.year_of_graduation || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="year_of_graduation"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" "
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueGenFormAlreadyInsured"
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Board of Education
                                </label>
                                <select
                                  onChange={handleInputChange}
                                  value={employeeData.board_of_education || ""}
                                  readOnly={editableSection !== "educational"}
                                  id="icueGenFormAlreadyInsured"
                                  name="board_of_education"
                                  // className="form-select text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="HBSE">HBSE</option>
                                  <option value="CBSE">CBSE</option>
                                  <option value="ICSE">ICSE</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Class 10 Percentage
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.calss_10_percentage || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="calss_10_percentage"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  // className={`form-control my-text my-text my-text icueGenFormInput   text-uppercase  ${
                                  //   isEditMode ? "" : "bg-white text-muted"
                                  // }`}
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="%"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Class 12 Percentage
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.class_12_percentage || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="class_12_percentage"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="%"
                                />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueGenFormAlreadyInsured"
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Class 12 Stream
                                </label>
                                <select
                                  onChange={handleInputChange}
                                  value={employeeData.class_12_stream || ""}
                                  readOnly={editableSection !== "educational"}
                                  id="icueGenFormAlreadyInsured"
                                  name="class_12_stream"
                                  // className="form-select text-uppercase icueGenFormInput   bg-white icueGenFormSel text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="Commerce">Commerce</option>
                                  <option value="Science">Science</option>
                                  <option value="Arts">Arts</option>
                                </select>
                              </div>
                              <br />
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.class_10_marksheet &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Upload Class 10 Marksheet
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="class_10_marksheet"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "class_10_marksheet",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.class_10_marksheet && (
                                      <p className="p-error">
                                        {errors.class_10_marksheet}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-6">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Class 10 Marksheet
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById(
                                              "class_10_marksheet"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.class_10_marksheet?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={employeeData.class_10_marksheet}
                                          width="100%"
                                          height="190px"
                                          title="class_10_marksheet Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.class_10_marksheet ||
                                            ImagePlaceholder
                                          }
                                          alt="class_10_marksheet"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("class_10_marksheet");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="class_10_marksheet"
                                            className="d-none"
                                            name="class_10_marksheet"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "class_10_marksheet",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.class_12_marksheet &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="w-100">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{
                                          display: "block",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        Upload Class 12 Marksheet
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group text-center">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label
                                          style={{
                                            display: "block",
                                            width: "100%",
                                          }}
                                        >
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="class_12_marksheet"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "class_12_marksheet",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.class_12_marksheet && (
                                      <p className="p-error">
                                        {errors.class_12_marksheet}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className=" col-xxl-8">
                                    <label
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                      style={{
                                        display: "block",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      Class 12 Marksheet
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        width: "100%",
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById(
                                              "class_12_marksheet"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.class_12_marksheet?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={employeeData.class_12_marksheet}
                                          width="100%"
                                          height="190px"
                                          title="class_12_marksheet Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.class_12_marksheet ||
                                            ImagePlaceholder
                                          }
                                          alt="class_12_marksheet"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("class_12_marksheet");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="class_12_marksheet"
                                            className="d-none"
                                            name="class_12_marksheet"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "class_12_marksheet",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-3">
                                {!employeeData.highest_qualification_marksheet &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div className="w-100">
                                    <label
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                      style={{
                                        display: "block",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      Upload Highest Qualification Marksheet
                                    </label>

                                    {photoLoad ? (
                                      <div className="Group text-center">
                                        <span className="spinner-border spinner-border-lg"></span>
                                      </div>
                                    ) : (
                                      <label
                                        style={{
                                          display: "block",
                                          width: "100%",
                                        }}
                                      >
                                        <img
                                          style={{
                                            height: "190px",
                                            // width: "100%",
                                            objectFit: "contain",
                                          }}
                                          src={ImagePlaceholder}
                                          alt="placeholder"
                                        />
                                        <input
                                          type="file"
                                          className="d-none"
                                          name="highest_qualification_marksheet"
                                          accept=".pdf,image/*"
                                          onChange={(e) =>
                                            handleFileChange(
                                              "highest_qualification_marksheet",
                                              e
                                            )
                                          }
                                        />
                                      </label>
                                    )}

                                    {errors.highest_qualification_marksheet && (
                                      <p className="p-error">
                                        {errors.highest_qualification_marksheet}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                      style={{
                                        display: "block",
                                        whiteSpace: "normal",
                                      }}
                                    >
                                      Highest Qualification Marksheet
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        width: "100%",
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById(
                                              "highest_qualification_marksheet"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.highest_qualification_marksheet?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={
                                            employeeData.highest_qualification_marksheet
                                          }
                                          width="100%"
                                          height="190px"
                                          title="highest_qualification_marksheet Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.highest_qualification_marksheet ||
                                            ImagePlaceholder
                                          }
                                          alt="highest_qualification_marksheet"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile(
                                                "highest_qualification_marksheet"
                                              );
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          <input
                                            type="file"
                                            id="highest_qualification_marksheet"
                                            className="d-none"
                                            name="highest_qualification_marksheet"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "highest_qualification_marksheet",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.certification_skill_acquired &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Upload Skills Acquired Certificate
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="certification_skill_acquired"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "certification_skill_acquired",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.certification_skill_acquired && (
                                      <p className="p-error">
                                        {errors.certification_skill_acquired}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Skills Acquired Certification
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById(
                                              "certification_skill_acquired"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.certification_skill_acquired?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={
                                            employeeData.certification_skill_acquired
                                          }
                                          width="100%"
                                          height="190px"
                                          title="certification_skill_acquired Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.certification_skill_acquired ||
                                            ImagePlaceholder
                                          }
                                          alt="certification_skill_acquired"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile(
                                                "certification_skill_acquired"
                                              );
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="certification_skill_acquired"
                                            className="d-none"
                                            name="certification_skill_acquired"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "certification_skill_acquired",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Skills Acquired
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.skill_acquired || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="skill_acquired"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" "
                                />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor=" "
                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                >
                                  Additional Courses
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={employeeData.additional_courses || ""}
                                  readOnly={editableSection !== "educational"}
                                  type="text"
                                  id=" "
                                  name="additional_courses"
                                  // className="form-control text-uppercase icueGenFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "educational"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" "
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.certification_additional_courses &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Additional Course Certificate
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="certification_additional_courses"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "certification_additional_courses",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.certification_additional_courses && (
                                      <p className="p-error">
                                        {
                                          errors.certification_additional_courses
                                        }
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Additional Course Certificate
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById(
                                              "certification_additional_courses"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.certification_additional_courses?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={
                                            employeeData.certification_additional_courses
                                          }
                                          width="100%"
                                          height="190px"
                                          title="certification_additional_courses Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.certification_additional_courses ||
                                            ImagePlaceholder
                                          }
                                          alt="certification_additional_courses"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile(
                                                "certification_additional_courses"
                                              );
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="certification_additional_courses"
                                            className="d-none"
                                            name="certification_additional_courses"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "certification_additional_courses",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.degree_upload &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Degree
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="degree_upload"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "degree_upload",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.degree_upload && (
                                      <p className="p-error">
                                        {errors.degree_upload}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Upload Degree
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "educational"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "educational")
                                          document
                                            .getElementById("degree_upload")
                                            .click();
                                      }}
                                    >
                                      {employeeData.degree_upload?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={employeeData.degree_upload}
                                          width="100%"
                                          height="190px"
                                          title="degree_upload Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.degree_upload ||
                                            ImagePlaceholder
                                          }
                                          alt="degree_upload"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "educational" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("degree_upload");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="degree_upload"
                                            className="d-none"
                                            name="degree_upload"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "degree_upload",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr></hr>{" "}
                          </div>
                        </div>
                        {/*  Previous Employment Details */}
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Previous Employment Details
                              </h4>
                            </div>
                            <div className="bg-white">
                              <button
                                type="button"
                                className="btn btn-transparent"
                                onClick={() => toggleEditMode("PreEmployment")}
                                id="icueEditGennInfoDetails"
                              >
                                {editableSection === "PreEmployment" ? (
                                  <>
                                    <i className="bi bi-x-circle" /> Cancel
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-pencil" /> Edit
                                  </>
                                )}
                              </button>
                              {editableSection === "PreEmployment" && (
                                <button
                                  type="button"
                                  className="btn btn-primary ms-2"
                                  onClick={handleUpdate}
                                  id="icueSaveGennInfoDetails"
                                >
                                  <i className="bi bi-save" /> Update
                                </button>
                              )}
                            </div>
                          </div>

                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            {/* <div className="bg-white">
                              <FontAwesomeIcon
                                icon={faTrash}
                                type="button"
                                className="btn btn-transparent icueTextInfoLight"
                                id="icueEditGennInfoDetails"
                                onClick={() => removeJobSection(index)}
                                style={{
                                  float: "right",
                                  color: "red",
                                  cursor: "pointer",
                                  fontSize: "20px",
                                }}
                              />
                            </div> */}
                            <div className="row">
                              {/* {workingCompany && workingCompany.length > 0 ? ( */}
                              {woorkingCompany.map((company, index) => (
                                <div className="row" key={index}>
                                  <div className="bg-white">
                                    <FontAwesomeIcon
                                      icon={faTrash}
                                      type="button"
                                      className="btn btn-transparent icueTextInfoLight"
                                      id="icueEditGennInfoDetails"
                                      onClick={() => removeJobSection(index)}
                                      style={{
                                        float: "right",
                                        color: "red",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                      }}
                                    />
                                  </div>
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`companyName`}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Company Name
                                    </label>
                                    <input
                                      value={company.company_name || ""}
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      type="text"
                                      onChange={(e) =>
                                        handleWorkingCompanyInputChange(
                                          index,
                                          e
                                        )
                                      }
                                      id={`companyName-`}
                                      name="company_name"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div>

                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`jobTitle-`}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Job Title
                                    </label>
                                    <input
                                      value={company.job_title || ""}
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      onChange={(e) =>
                                        handleWorkingCompanyInputChange(
                                          index,
                                          e
                                        )
                                      }
                                      type="text"
                                      id={`jobTitle-`}
                                      name="job_title"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div>
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`startDate-${company.id}`}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Start Date
                                    </label>
                                    <input
                                      value={
                                        company.start_date
                                          ? new Date(company.start_date)
                                              .toISOString()
                                              .split("T")[0]
                                          : ""
                                      }
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      type="date"
                                      onChange={(e) =>
                                        handleWorkingCompanyInputChange(
                                          index,
                                          e
                                        )
                                      }
                                      id={`startDate-${company.id}`}
                                      name="start_date"
                                      // className="form-control text-uppercase icueGennFormInput bg-white text-muted "
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div>

                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`endDate- `}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      End Date
                                    </label>
                                    <input
                                      value={
                                        company.end_date
                                          ? new Date(company.end_date)
                                              .toISOString()
                                              .split("T")[0]
                                          : ""
                                      }
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      type="date"
                                      onChange={(e) =>
                                        handleWorkingCompanyInputChange(
                                          index,
                                          e
                                        )
                                      }
                                      id={`endDate- `}
                                      name="end_date"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div>
                                  {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`payslip- `}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Upload Payslip
                                    </label>
                                    <input
                                      type="file"
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      id={`payslip- `}
                                      onChange={handleInputChange}
                                      name="payslip"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                           : "bg-white text-muted"
                                      }`}
                                    />
                                  </div> */}
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label>Pay Slip</label>

                                    <div className="pt-2">
                                      {company.pay_slip ? (
                                        <div className="img-preview">
                                          {/* Preview Image or PDF */}
                                          {company.pay_slip.endsWith(".pdf") ? (
                                            <iframe
                                              // src={company.pay_slip}
                                              title="Payslip Preview"
                                              width="100%"
                                              height="190px"
                                              style={{
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                              }}
                                            ></iframe>
                                          ) : (
                                            <img
                                              src={company.pay_slip}
                                              alt="Payslip Preview"
                                              style={{
                                                maxHeight: "190px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          )}

                                          {/* Delete icon (only if editable) */}
                                          {/* {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )} */}
                                        </div>
                                      ) : (
                                        <div className="img-preview">
                                          <img
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                            style={{ height: "190px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`relievingLetter- `}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Upload Relieving Letter
                                    </label>
                                    <input
                                      type="file"
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      onChange={handleInputChange}
                                      id={`relievingLetter- `}
                                      name="relievingLetter"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div> */}
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label>Relieving Letter</label>

                                    <div className="pt-2">
                                      {company.relieving_letter ? (
                                        <div className="img-preview">
                                          {/* Preview Image or PDF */}
                                          {company.relieving_letter.endsWith(
                                            ".pdf"
                                          ) ? (
                                            <iframe
                                              // src={company.relieving_letter}
                                              title="relieving_letter Preview"
                                              width="100%"
                                              height="190px"
                                              style={{
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                              }}
                                            ></iframe>
                                          ) : (
                                            <img
                                              src={company.relieving_letter}
                                              alt="relieving_letter Preview"
                                              style={{
                                                maxHeight: "190px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          )}

                                          {/* Delete icon (only if editable) */}
                                          {/* {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )} */}
                                        </div>
                                      ) : (
                                        <div className="img-preview">
                                          <img
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                            style={{ height: "190px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`resignationLetter- `}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Upload Signed Resignation Letter
                                    </label>
                                    <input
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      type="file"
                                      onChange={handleInputChange}
                                      id={`resignationLetter- `}
                                      name="resignationLetter"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div> */}
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label>Signed Resignation Letter</label>

                                    <div className="pt-2">
                                      {company.signed_resignation_letter ? (
                                        <div className="img-preview">
                                          {/* Preview Image or PDF */}
                                          {company.signed_resignation_letter.endsWith(
                                            ".pdf"
                                          ) ? (
                                            <iframe
                                              // src={company.signed_resignation_letter}
                                              title="signed_resignation_letter Preview"
                                              width="100%"
                                              height="190px"
                                              style={{
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                              }}
                                            ></iframe>
                                          ) : (
                                            <img
                                              src={
                                                company.signed_resignation_letter
                                              }
                                              alt="signed_resignation_letter Preview"
                                              style={{
                                                maxHeight: "190px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          )}

                                          {/* Delete icon (only if editable) */}
                                          {/* {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )} */}
                                        </div>
                                      ) : (
                                        <div className="img-preview">
                                          <img
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                            style={{ height: "190px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                    <label
                                      htmlFor={`offerLetter- `}
                                      className="form-label icueTextPrimary icueGennInfoLabel mt-3"
                                    >
                                      Upload Offer Letter
                                    </label>
                                    <input
                                      type="file"
                                      readOnly={
                                        editableSection !== "PreEmployment"
                                      }
                                      onChange={handleInputChange}
                                      id={`offerLetter- `}
                                      name="offerLetter"
                                      // className="form-control text-uppercase icueGennFormInput   bg-white text-muted"
                                      className={`form-control my-text my-text my-text ${
                                        editableSection === "PreEmployment"
                                          ? ""
                                          : "bg-white text-muted"
                                      }`}
                                    />
                                  </div> */}
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label> Offer Letter</label>

                                    <div className="pt-2">
                                      {company.offer_letter ? (
                                        <div className="img-preview">
                                          {/* Preview Image or PDF */}
                                          {company.offer_letter.endsWith(
                                            ".pdf"
                                          ) ? (
                                            <iframe
                                              // src={company.offer_letter}
                                              title="offer_letter Preview"
                                              width="100%"
                                              height="190px"
                                              style={{
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                              }}
                                            ></iframe>
                                          ) : (
                                            <img
                                              src={company.offer_letter}
                                              alt="offer_letter Preview"
                                              style={{
                                                maxHeight: "190px",
                                                borderRadius: "4px",
                                              }}
                                            />
                                          )}

                                          {/* Delete icon (only if editable) */}
                                          {/* {!isDisabled && (
                                            <img
                                              onClick={() =>
                                                deleteFile("pay_slip", index)
                                              }
                                              className="clear"
                                              src={X}
                                              alt="clear-preview"
                                            />
                                          )} */}
                                        </div>
                                      ) : (
                                        <div className="img-preview">
                                          <img
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                            style={{ height: "190px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>

                            <hr />
                          </div>

                          {/* Add More Company Button */}
                          <button
                            type="button"
                            onClick={addJobSection}
                            style={{
                              marginTop: "20px",
                              marginLeft: "20px",
                              padding: "10px 20px",
                              backgroundColor: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            Add More Company
                          </button>
                        </div>
                        {/* Employment Details */}
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Employment Details
                              </h4>
                            </div>
                            <div className="bg-white">
                              <button
                                type="button"
                                className="btn btn-transparent"
                                onClick={() => toggleEditMode("Employment")}
                                id="icueEditEmpInfoDetails"
                              >
                                {editableSection === "Employment" ? (
                                  <>
                                    <i className="bi bi-x-circle" /> Cancel
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-pencil" /> Edit
                                  </>
                                )}
                              </button>
                              {editableSection === "Employment" && (
                                <button
                                  type="button"
                                  className="btn btn-primary ms-2"
                                  onClick={handleUpdate}
                                  id="icueSaveGEmpInfoDetails"
                                >
                                  <i className="bi bi-save" /> Update
                                </button>
                              )}
                            </div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsured"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Employee ID
                                </label>
                                <input
                                  value={employeeData.employee_id || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsured"
                                  name="employee_id"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="55555"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Position
                                </label>
                                <input
                                  type="text"
                                  value={employeeData.joining_position || ""}
                                  readOnly={editableSection !== "Employment"}
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="joining_position"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="Manager"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Department
                                </label>
                                <input
                                  type="text"
                                  value={employeeData.department || ""}
                                  readOnly={editableSection !== "Employment"}
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="department"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="IT"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Reporting Manager
                                </label>
                                <input
                                  value={employeeData.reporting_manager || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="reporting_manager"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Joining Date
                                </label>
                                <input
                                  onChange={handleInputChange}
                                  value={
                                    employeeData.joining_date
                                      ? new Date(employeeData.joining_date)
                                          .toISOString()
                                          .split("T")[0]
                                      : ""
                                  }
                                  readOnly={editableSection !== "Employment"}
                                  type="date"
                                  id="icueEmpFormTypeInsurance"
                                  name="joining_date"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  //
                                  defaultValue=""
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Work Location
                                </label>
                                <input
                                  value={employeeData.work_location || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="work_location"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue="INdia"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormAlreadyInsured"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Employment Type
                                </label>
                                <select
                                  value={employeeData.employee_type || ""}
                                  readOnly={editableSection !== "Employment"}
                                  onChange={handleInputChange}
                                  id="icueEmpFormAlreadyInsured"
                                  name="employee_type"
                                  // className="form-select text-uppercase icueEmpFormInput   bg-white icueEmpFormSel text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                >
                                  <option value="FullTimeEmployee">
                                    Full Time Employee
                                  </option>
                                  <option value="Trainee">Trainee</option>
                                  <option value="Internship">Internship</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Shift Time
                                </label>
                                <select
                                  value={employeeData.shift_timing || ""}
                                  readOnly={editableSection !== "Employment"}
                                  onChange={handleInputChange}
                                  id="icueEmpFormAlreadyInsured"
                                  name="shift_timing"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  // className="form-select text-uppercase icueEmpFormInput   bg-white icueEmpFormSel text-muted"
                                >
                                  <option value="morning">Morning</option>
                                  <option value="evening">Evening</option>
                                  <option value="night">Night</option>
                                </select>
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Basic Salary
                                </label>
                                <input
                                  value={employeeData.basic_salary || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="basic_salary"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  HRA
                                </label>
                                <input
                                  value={employeeData.hra || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="hra"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Conveyance
                                </label>
                                <input
                                  value={employeeData.conveyance || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="conveyance"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Special Allowance
                                </label>
                                <input
                                  value={employeeData.special_allowance || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="special_allowance"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Gross Salary
                                </label>
                                <input
                                  value={employeeData.gross_salary || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="gross_salary"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Provident Fund
                                </label>
                                <input
                                  value={employeeData.provident_fund || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="provident_fund"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  ESI
                                </label>
                                <input
                                  value={employeeData.ESI || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="ESI"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Total CTC
                                </label>
                                <input
                                  value={employeeData.inhand_salary || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="inhand_salary"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Refrence 1
                                </label>
                                <input
                                  value={employeeData.reference1 || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="reference1"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                                <label
                                  htmlFor="icueEmpFormTypeInsurance"
                                  className="form-label icueTextPrimary icueEmpInfoLabel mt-3"
                                >
                                  Refrence 2
                                </label>
                                <input
                                  value={employeeData.reference2 || ""}
                                  readOnly={editableSection !== "Employment"}
                                  type="text"
                                  onChange={handleInputChange}
                                  id="icueEmpFormTypeInsurance"
                                  name="reference2"
                                  // className="form-control text-uppercase icueEmpFormInput   bg-white text-muted"
                                  className={`form-control my-text my-text my-text ${
                                    editableSection === "Employment"
                                      ? ""
                                      : "bg-white text-muted"
                                  }`}
                                  defaultValue=" abc"
                                />
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.policicue_offer_letter &&
                                editableSection === "Employment" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Policicue offerLetter
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="policicue_offer_letter"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "policicue_offer_letter",
                                                e
                                              )
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.policicue_offer_letter && (
                                      <p className="p-error">
                                        {errors.policicue_offer_letter}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Upload Policicue OfferLetter
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "Employment"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "Employment")
                                          document
                                            .getElementById(
                                              "policicue_offer_letter"
                                            )
                                            .click();
                                      }}
                                    >
                                      {employeeData.policicue_offer_letter?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={
                                            employeeData.policicue_offer_letter
                                          }
                                          width="100%"
                                          height="190px"
                                          title="policicue_offer_letter Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.policicue_offer_letter ||
                                            ImagePlaceholder
                                          }
                                          alt="policicue_offer_letter"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "Employment" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile(
                                                "policicue_offer_letter"
                                              );
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="policicue_offer_letter"
                                            className="d-none"
                                            name="policicue_offer_letter"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange(
                                                "policicue_offer_letter",
                                                e
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr></hr>

                            {/* Resignation Checkbox */}
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mt-4">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="resignationCheckbox"
                                  checked={employeeData.is_resigned || false}
                                  disabled={editableSection !== "Employment"}
                                  onChange={(e) =>
                                    setEmployeeData({
                                      ...employeeData,
                                      is_resigned: e.target.checked,
                                    })
                                  }
                                />
                                <label
                                  className="form-check-label icueTextPrimary "
                                  htmlFor="resignationCheckbox"
                                >
                                  Resignation status: Yes
                                </label>
                              </div>

                              {/* Conditional Resignation Section */}
                            </div>
                            {employeeData.is_resigned && (
                              <div className="col-12 mt-3">
                                <div
                                  className="accordion"
                                  id="resignationAccordion"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="headingOne"
                                    >
                                      <button
                                        className="accordion-button "
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Resignation Details
                                      </button>
                                    </h2>
                                    <div
                                      id="collapseOne"
                                      className="accordion-collapse collapse show"
                                      aria-labelledby="headingOne"
                                      data-bs-parent="#resignationAccordion"
                                    >
                                      <div className="accordion-body row">
                                        {/* Resignation Date */}
                                        <div className="col-md-4">
                                          <label className="form-label icueTextPrimary">
                                            Date of Resignation
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="date_of_resignation"
                                            value={
                                              employeeData.date_of_resignation
                                                ? new Date(
                                                    employeeData.date_of_resignation
                                                  )
                                                    .toISOString()
                                                    .split("T")[0]
                                                : ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          />
                                        </div>

                                        {/* Notice Period */}
                                        <div className="col-md-4">
                                          <label className="form-label icueTextPrimary">
                                            Notice Period Start Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="notice_period_start_date"
                                            value={
                                              employeeData.notice_period_start_date
                                                ? new Date(
                                                    employeeData.notice_period_start_date
                                                  )
                                                    .toISOString()
                                                    .split("T")[0]
                                                : ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          />
                                        </div>
                                        <div className="col-md-4">
                                          <label className="form-label icueTextPrimary">
                                            Notice Period End Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            name="notice_period_end_date"
                                            value={
                                              employeeData.notice_period_end_date
                                                ? new Date(
                                                    employeeData.notice_period_end_date
                                                  )
                                                    .toISOString()
                                                    .split("T")[0]
                                                : ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          />
                                        </div>
                                        <div className="col-md-4 py-4">
                                          <label className="form-label icueTextPrimary">
                                            Resignation Type
                                          </label>
                                          <select
                                            className="form-select"
                                            name="resignation_type"
                                            value={
                                              employeeData.resignation_type ||
                                              ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          >
                                            <option value="">Select</option>
                                            <option value="Voluntary">
                                              Voluntary
                                            </option>

                                            <option value="Termination">
                                              Termination
                                            </option>
                                            <option value="Retirement">
                                              Retirement
                                            </option>
                                            <option value="Other">Other</option>
                                          </select>
                                        </div>
                                        {/* FNF Status */}
                                        <div className="col-md-4 py-4">
                                          <label className="form-label icueTextPrimary">
                                            F&F Status
                                          </label>
                                          <select
                                            className="form-select"
                                            name="f_and_f_status"
                                            value={
                                              employeeData.f_and_f_status || ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          >
                                            <option value="">Select</option>
                                            <option value="Pending">
                                              Pending
                                            </option>
                                            <option value="Completed">
                                              Completed
                                            </option>
                                          </select>
                                        </div>
                                        {/* upload Releiving letter */}
                                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                          {!employeeData.relieving_letter &&
                                          editableSection === "Employment" ? (
                                            // CASE 1: No file selected & section is in edit mode
                                            <div>
                                              <div className="pt-2">
                                                <label
                                                  className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                                  style={{ display: "block" }}
                                                >
                                                  Releiving Letter
                                                </label>

                                                {photoLoad ? (
                                                  <div className="Group">
                                                    <span className="spinner-border spinner-border-lg"></span>
                                                  </div>
                                                ) : (
                                                  <label
                                                    style={{ display: "block" }}
                                                  >
                                                    <img
                                                      style={{
                                                        height: "190px",
                                                        objectFit: "contain",
                                                      }}
                                                      src={ImagePlaceholder}
                                                      alt="placeholder"
                                                    />

                                                    <input
                                                      type="file"
                                                      className="d-none"
                                                      name="relieving_letter"
                                                      accept=".pdf,image/*"
                                                      onChange={(e) =>
                                                        handleFileChange(
                                                          "relieving_letter",
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </label>
                                                )}
                                              </div>

                                              {errors.relieving_letter && (
                                                <p className="p-error">
                                                  {errors.relieving_letter}
                                                </p>
                                              )}
                                            </div>
                                          ) : (
                                            // CASE 2: File is present OR section is not editable
                                            <div>
                                              <label
                                                htmlFor=" "
                                                className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                              >
                                                Upload Relieving Letter
                                              </label>
                                              <div
                                                className="img-preview position-relative"
                                                style={{
                                                  cursor:
                                                    editableSection ===
                                                    "Employment"
                                                      ? "pointer"
                                                      : "default",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    editableSection ===
                                                    "Employment"
                                                  )
                                                    document
                                                      .getElementById(
                                                        "relieving_letter"
                                                      )
                                                      .click();
                                                }}
                                              >
                                                {employeeData.relieving_letter?.endsWith(
                                                  ".pdf"
                                                ) ? (
                                                  <iframe
                                                    src={
                                                      employeeData.relieving_letter
                                                    }
                                                    width="100%"
                                                    height="190px"
                                                    title="relieving_letter Preview"
                                                  />
                                                ) : (
                                                  <img
                                                    src={
                                                      employeeData.relieving_letter ||
                                                      ImagePlaceholder
                                                    }
                                                    alt="relieving_letter"
                                                    style={{
                                                      height: "190px",
                                                      width: "100%",
                                                      objectFit: "contain",
                                                    }}
                                                  />
                                                )}

                                                {editableSection ===
                                                  "Document" && (
                                                  <>
                                                    <img
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        deleteFile(
                                                          "relieving_letter"
                                                        );
                                                      }}
                                                      className="clear"
                                                      src={X}
                                                      alt="clear-preview"
                                                      style={{
                                                        position: "absolute",
                                                        // top: "5px",
                                                        // right: "5px",
                                                        // width: "20px",
                                                        // height: "20px",
                                                        cursor: "pointer",
                                                      }}
                                                    />

                                                    {/* Hidden input triggered by image click */}
                                                    <input
                                                      type="file"
                                                      id="relieving_letter"
                                                      className="d-none"
                                                      name="relieving_letter"
                                                      accept=".pdf,image/*"
                                                      onChange={(e) =>
                                                        handleFileChange(
                                                          "relieving_letter",
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                        {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3">
                                          <label
                                            htmlFor=" "
                                            className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                          >
                                            Upload Relieving Letter
                                          </label>

                                          <div className="pt-2">
                                            {employeeData.relieving_letter ? (
                                              <div className="img-preview">
                                                {employeeData.relieving_letter.endsWith(
                                                  ".pdf"
                                                ) ? (
                                                  <iframe
                                                    title="Relieving Preview"
                                                    width="100%"
                                                    height="190px"
                                                    style={{
                                                      border: "1px solid #ccc",
                                                      borderRadius: "4px",
                                                    }}
                                                  ></iframe>
                                                ) : (
                                                  <img
                                                    src={
                                                      employeeData.relieving_letter
                                                    }
                                                    alt="Relieving Preview"
                                                    style={{
                                                      maxHeight: "190px",
                                                      borderRadius: "4px",
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            ) : (
                                              <div className="img-preview">
                                                <img
                                                  src={ImagePlaceholder}
                                                  alt="placeholder"
                                                  style={{ height: "190px" }}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </div> */}
                                        {/* Resignation Reason */}
                                        <div className="col-12 mt-3">
                                          <label className="form-label icueTextPrimary">
                                            Reason for Resignation
                                          </label>
                                          <textarea
                                            className="form-control"
                                            rows={3}
                                            name="resignation_reason"
                                            value={
                                              employeeData.resignation_reason ||
                                              ""
                                            }
                                            onChange={handleInputChange}
                                            disabled={
                                              editableSection !== "Employment"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Document Verification */}
                        <div
                          className="bg-white shadow p-4 pb-5 rounded-3"
                          style={{
                            marginTop: "4rem",
                            marginLeft: "0.8rem",
                            marginRight: "0.8rem",
                          }}
                        >
                          <div className="d-flex justify-content-between pb-4 border-bottom py-0 mb-3">
                            <div className="bg-white">
                              <h4
                                className="text-capitalize icueTextPrimary"
                                style={{ fontFamily: "ErasDemiITC" }}
                              >
                                Document Verification
                              </h4>
                            </div>
                            <div className="bg-white">
                              <button
                                type="button"
                                className="btn btn-transparent"
                                onClick={() => toggleEditMode("Document")}
                                id="icueEditDocInfoDetails"
                              >
                                {editableSection === "Document" ? (
                                  <>
                                    <i className="bi bi-x-circle" /> Cancel
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-pencil" /> Edit
                                  </>
                                )}
                              </button>
                              {editableSection === "Document" && (
                                <button
                                  type="button"
                                  className="btn btn-primary ms-2"
                                  onClick={handleUpdate}
                                  id="icueSaveDocInfoDetails"
                                >
                                  <i className="bi bi-save" /> Update
                                </button>
                              )}
                            </div>
                          </div>
                          <div
                            className="multisteps-form__content"
                            style={{ fontFamily: "Calibri" }}
                          >
                            <div className="row">
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.adhar &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        Aadhaar Card
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="adhar"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("adhar", e)
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.adhar && (
                                      <p className="p-error">{errors.adhar}</p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Upload Aadhar
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "Document"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "Document")
                                          document
                                            .getElementById("adhar")
                                            .click();
                                      }}
                                    >
                                      {employeeData.adhar?.endsWith(".pdf") ? (
                                        <iframe
                                          src={employeeData.adhar}
                                          width="100%"
                                          height="190px"
                                          title="adhar Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.adhar ||
                                            ImagePlaceholder
                                          }
                                          alt="adhar"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "Document" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("adhar");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="adhar"
                                            className="d-none"
                                            name="adhar"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("adhar", e)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.pan &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        pan Card
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="pan"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("pan", e)
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.pan && (
                                      <p className="p-error">{errors.pan}</p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Upload Pan Card
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "Document"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "Document")
                                          document
                                            .getElementById("pan")
                                            .click();
                                      }}
                                    >
                                      {employeeData.pan?.endsWith(".pdf") ? (
                                        <iframe
                                          src={employeeData.pan}
                                          width="100%"
                                          height="190px"
                                          title="pan Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.pan || ImagePlaceholder
                                          }
                                          alt="pan"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "Document" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("pan");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="pan"
                                            className="d-none"
                                            name="pan"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("pan", e)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-3 ">
                                {!employeeData.passport &&
                                editableSection === "educational" ? (
                                  // CASE 1: No file selected & section is in edit mode
                                  <div>
                                    <div className="pt-2">
                                      <label
                                        className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                        style={{ display: "block" }}
                                      >
                                        passport Card
                                      </label>

                                      {photoLoad ? (
                                        <div className="Group">
                                          <span className="spinner-border spinner-border-lg"></span>
                                        </div>
                                      ) : (
                                        <label style={{ display: "block" }}>
                                          <img
                                            style={{
                                              height: "190px",
                                              objectFit: "contain",
                                            }}
                                            src={ImagePlaceholder}
                                            alt="placeholder"
                                          />

                                          <input
                                            type="file"
                                            className="d-none"
                                            name="passport"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("passport", e)
                                            }
                                          />
                                        </label>
                                      )}
                                    </div>

                                    {errors.passport && (
                                      <p className="p-error">
                                        {errors.passport}
                                      </p>
                                    )}
                                  </div>
                                ) : (
                                  // CASE 2: File is present OR section is not editable
                                  <div className="col-xxl-8">
                                    <label
                                      htmlFor=" "
                                      className="form-label icueTextPrimary icueGenInfoLabel mt-3"
                                    >
                                      Upload passport Card
                                    </label>
                                    <div
                                      className="img-preview position-relative"
                                      style={{
                                        cursor:
                                          editableSection === "Document"
                                            ? "pointer"
                                            : "default",
                                      }}
                                      onClick={() => {
                                        if (editableSection === "Document")
                                          document
                                            .getElementById("passport")
                                            .click();
                                      }}
                                    >
                                      {employeeData.passport?.endsWith(
                                        ".pdf"
                                      ) ? (
                                        <iframe
                                          src={employeeData.passport}
                                          width="100%"
                                          height="190px"
                                          title="passport Preview"
                                        />
                                      ) : (
                                        <img
                                          src={
                                            employeeData.passport ||
                                            ImagePlaceholder
                                          }
                                          alt="passport"
                                          style={{
                                            height: "190px",
                                            width: "100%",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {editableSection === "Document" && (
                                        <>
                                          <img
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              deleteFile("passport");
                                            }}
                                            className="clear"
                                            src={X}
                                            alt="clear-preview"
                                            style={{
                                              position: "absolute",
                                              // top: "5px",
                                              // right: "5px",
                                              // width: "20px",
                                              // height: "20px",
                                              cursor: "pointer",
                                            }}
                                          />

                                          {/* Hidden input triggered by image click */}
                                          <input
                                            type="file"
                                            id="passport"
                                            className="d-none"
                                            name="passport"
                                            accept=".pdf,image/*"
                                            onChange={(e) =>
                                              handleFileChange("passport", e)
                                            }
                                          />
                                        </>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr></hr>
                          </div>
                          <button
                            className="signup-btn"
                            style={{
                              backgroundColor: "#007bff",
                              width: "270px",
                              height: "50px",
                              border: "none",
                              borderRadius: "25px",
                              alignItems: "center",
                              color: "#fff",
                              fontWeight: "normal",
                              margin: " 20px 0",
                              fontFamily: "ERASDEMIITC",
                              fontSize: "1rem",
                            }}
                            type="submit"
                            onClick={handleSubmit}
                          >
                            Submit Details
                          </button>
                          <button
                            className="signup-btn"
                            style={{
                              backgroundColor: "#007bff",
                              width: "270px",
                              height: "50px",
                              border: "none",
                              borderRadius: "25px",
                              marginLeft: "50px",
                              color: "#fff",
                              marginLeft: "10px",
                              fontWeight: "normal",
                              margin: " 20px 0",
                              fontFamily: "ERASDEMIITC",
                              fontSize: "1rem",
                            }}
                            type="button"
                            onClick={handleOpenModal}
                          >
                            View Checklist
                          </button>
                          {/* <Modal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>
                                Employee Joining Kit Checklist
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <p> 
                                Kindly share your documents within 2 days from
                                your joining date to process your joining with
                                Policicue. Failing to submit the above-mentioned
                                documents may null and void Policicue offer.
                              </p>
                              <ListGroup>
                                {documents.map((doc, index) => (
                                  <ListGroup.Item
                                    key={doc.id}
                                    className="checklist-item"
                                  >
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={checkedItems[index]}
                                        onChange={() =>
                                          handleCheckboxChangee(index)
                                        }
                                      />
                                      {doc.name}
                                    </label>
                                    <span className="checklist-description">
                                      {" "}
                                      - {doc.remarks}
                                    </span>
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={() => setShowModal(false)}
                              >
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal> */}
                          <Modal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            centered
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>
                                Employee Joining Kit Checklist
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <ListGroup>
                                {checklistData &&
                                  checklistMap.map((item, index) => (
                                    <ListGroup.Item
                                      key={index}
                                      className="checklist-item"
                                    >
                                      <label
                                        style={{
                                          fontSize: "1.1rem",
                                          fontWeight: "500",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={
                                            checklistData[item.key] === 1
                                          }
                                          style={{ Col: "blue" }}
                                          disabled
                                        />
                                        {item.name}
                                      </label>
                                    </ListGroup.Item>
                                  ))}
                              </ListGroup>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                onClick={() => setShowModal(false)}
                              >
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
